import { ApiError, fetchWithAuth } from "@entities/user-tokens";

import type { PortalReference } from "../PortalReference";

/** 入力 URL が社内ポータルのページ URL として無効（400）＝プレビュー不可を判別する。 */
export class PortalInvalidUrlError extends Error {
    constructor() {
        super("有効な社内ポータルのページ URL ではありません");
        this.name = "PortalInvalidUrlError";
    }
}

/**
 * ライブ参照を取得する（`GET /portal/reference`）。
 *
 * 所在は入力 URL で与える。企業ページなら活動履歴と企業ドキュメント、案件ページなら案件資料が
 * 返る（加算方式）。**表示は保存済みの連携ではなく入力中の URL に追従させる**ため、案件の保存前でも
 * 何が連携対象になるかを確かめられる。
 *
 * 解決した所在 id も返る。URL を入力しただけでは id が分からず、資料へのリンクを組み立てられない
 * ため（コンソールのポータル資料は案件 id と ref の組で識別する）。
 */
export async function fetchPortalPreview(url: string): Promise<PortalReference> {
    const res = await fetchWithAuth(`/portal/reference?url=${encodeURIComponent(url)}`, {
        headers: { Accept: "application/json" },
    });
    if (res.status === 400) throw new PortalInvalidUrlError();
    if (!res.ok) throw await ApiError.fromResponse(res, "社内ポータルの取得に失敗しました");
    const body = (await res.json()) as Partial<PortalReference>;
    return {
        portalCompanyId: body.portalCompanyId ?? null,
        portalProjectId: body.portalProjectId ?? null,
        portalActivities: body.portalActivities ?? [],
        portalDocuments: body.portalDocuments ?? [],
        portalProjectDocs: body.portalProjectDocs ?? [],
    };
}
